// client/src/coms/views/games_parts/gamesVisibility.js
// Whether the game on screen is actually visible. The Voxemera shell keeps a running game mounted while
// another area is open; heavy parts (the Canvas editor of a drawing game) only run while it is visible.
import { createContext } from 'react';

export const GamesVisibleContext = createContext(true);
